// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import Config from './appcounfig'
import dosageForm from '../views/dosage-form/store'
import manufacturingSite from '../views/manufacturing-site/store'
import nationallistcategories from '../views/nationallist-categories/store'
import nationallist from '../views/nationallist/store'
import appLookups from './stores/lookups'
import allCaseTypes from '../views/case-management/ChooseCaseType/store'
import invoice from '../views/invoices/store'
import manufacturingSiteOldData from '../views/manufacturing-site-old-data/store'
import serviceItem from '../views/service-item/store'
import approvance from '../views/approvance/store'
import decisionDraft from '../views/decision-draft/store'
import nameSimilarity from '../views/name-similarity/store'
const rootReducer = {
  auth,
  navbar,
  layout,
  Config,
  dosageForm,
  manufacturingSite,
  nationallistcategories,
  nationallist,
  appLookups,
  allCaseTypes,
  invoice,
  manufacturingSiteOldData,
  serviceItem,
  approvance,
  decisionDraft,
  nameSimilarity
}

export default rootReducer
